// extracted by mini-css-extract-plugin
export default {"sigPad":"styles_sigPad__MhGBD","contractInput":"styles_contractInput__BrQX4"};